module.exports = __webpack_public_path__ + "img/1.ac6d03dc.jpg";